module.exports = __webpack_public_path__ + "img/ИФ-1(А)-030.f0cfbb33.png";